import cn from 'classnames';
import styles from './HintText.module.css';

type Props = {
  children: React.ReactNode;
  id?: string;
  className?: string;
};

/**
 * {@link HintText} is intended to be used below a form field to give extra information,
 * such as realtime feedback about the user's input.
 */
export function HintText({ children, id, className }: Props) {
  return (
    <div id={id} className={cn(styles.HintText, className)}>
      {children}
    </div>
  );
}
